// extracted by mini-css-extract-plugin
export default {"container":"Oo-z","bubbleNav":"Po-z","graphic":"Qo-z","contact":"Ro-z"};